import { Component } from '@angular/core';
import { FinegrainRolesService } from '../../common/services/finegrain-roles/finegrain-roles.service';
import { AuthenticationService } from '../../authentication/authentication.service';
import { NgIf } from '@angular/common';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-vcm-main',
    templateUrl: './vcm-main.component.html',
    styleUrls: ['./vcm-main.component.scss'],
    imports: [NgIf, RouterOutlet]
})
export class VcmMainComponent {
  constructor(private fineGrainService: FinegrainRolesService,
    private authService: AuthenticationService,
    ) {}
  /**
  * Property deletmine is fanda authorized
  **/
  public get isAuthorizedVcm(): boolean {
    return this.fineGrainService.getPortalPermissions('vcm');
  }
}
